import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
// import {OrderedMap} from 'immutable';
import {
    injectIntl, 
    defineMessages, 
    // intlShape
} from 'react-intl';
import './drawer.css';
import bindAll from 'lodash.bindall';
import monitorList from './assets/monitorList.png';
import monitorX from './assets/monitorX.png';
// import MataMonitorListComponent from './components/mata-monitor-list/monitor-list';
import MataVariableComponent from './components/mata-monitor-list/mata-variable'


const messages = defineMessages({
    variable: {
        defaultMessage: 'Variable', description: 'Variable', id: 'gui.homePage.variable'
    },
    monitorNoVariable: {
        defaultMessage: 'No variables added', description: 'No variables added', id: 'gui.homePage.monitorNoVariable'
    },
    monitorListTilte: {
        defaultMessage: 'Tabulation', description: 'Tabulation', id: 'gui.homePage.monitorListTilte'
    },
    monitorNoList: {
        defaultMessage: 'List not added', description: 'List not added', id: 'gui.homePage.monitorNoList'
    }
});

class MonitorComponent extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, ['handleChange', 'onSwitchChange']);
        this.state = {
            activeIndex: 0, switchState: true
        };
        this.componentReady = React.createRef();
    }

    componentDidMount () {
        this.componentReady.current = true;
        // this.onUpdateStyle();
    }

    shouldComponentUpdate (nextProps, nextState) {
        // activeIndex, callback, controlRef, segments
        return nextState;
    }

    componentDidUpdate () {
        // this.onUpdateStyle();
    }

    componentWillUnmount () {
        // recycle the DOM nodes
        this.props.segments.forEach(segment => {
            segment.ref.current.remove();
        });
        this.componentReady = null;
    }

    handleChange (e) {
        // this.props.callback(e.target.value);
    }

    onSwitchChange (value) {
        this.setState({
            switchState: value
        });
    }


    render () {
        const {
            intl
        } = this.props;
        return (<div
            className="monitorContainer"
            ref={this.props.controlRef}
        >
            <div className="monitorX">
                <div className="monitorTop">
                    <div style={{padding: '8px 20px'}}>
                        <span style={{float: 'left'}}>
                            {intl.formatMessage(messages.variable)}
                        </span>
                        <img
                            style={{float: 'right', marginTop: '4px'}}
                            height="14"
                            width="22"
                            src={monitorX}
                        />
                    </div>
                </div>
                <div>
                    {/* {this.props.variableList} */}
                    <MataVariableComponent monitors={this.props.variableList} />
                </div>
            </div>
        </div>);
    }
}

MonitorComponent.defaultProps = {
    callback: () => {
    },
    controlRef: React.createRef(),
    segments: [],
    list: [{a: 1}]
};

MonitorComponent.propTypes = {
    // intl: intlShape.isRequired,
    name: PropTypes.string,
    list: PropTypes.array,
    callback: PropTypes.func,
    defaultIndex: PropTypes.number,
    controlRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({current: PropTypes.instanceOf(Element)})]),
    // monitors: PropTypes.objectOf(OrderedMap)
};
const mapStateToProps = state => ({
    // monitors: state.scratchGui.mataMonitors, // monitorsList: state.scratchGui.mataMonitors.valueSeq().filter(m => m.mode === 'list'),
    // isShow: state.drawerStore.isShow,
    variableList: state.apiStore.variableList
    // isFirmwareMode: state.scratchGui.mode.isFirmwareUpload,
    // isConnected: state.scratchGui.connectionModal.isConnected
});

export default injectIntl(connect(mapStateToProps)(MonitorComponent));
